import { useQuery } from "@tanstack/react-query";
import { GenericErrorType, MaintenanceReport } from "../../models";
import { useApiClient } from "../apiClient/apiClient";

const refetchInterval = 1000 * 30;

export function useMaintenanceReports() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ["maintenances"],
    queryFn: () => apiClient.get<MaintenanceReport[]>("maintenances/lion", GenericErrorType.UNSPECIFIED),
    gcTime: 0,
    refetchInterval,
    retry: 2
  });
}
